module.exports = __webpack_public_path__ + "img/x571gt.7a032d72.jpg";